import { j as a, c } from "./utils-BdNIfrGQ.js";
import { c as n } from "./index-Di82Y7n3.js";
const s = n("", {
  variants: {
    variant: {
      cerbicon: "max-w-[90px]",
      emptyState: "max-w-[128px] w-full",
      illustration: "max-w-[300px] w-full"
    }
  },
  defaultVariants: {
    variant: "cerbicon"
  }
}), m = ({ variant: r, src: t, alt: e, ...i }) => /* @__PURE__ */ a.jsx("div", { className: c(s({ variant: r }), "relative"), "aria-hidden": !0, ...i, children: /* @__PURE__ */ a.jsx("img", { src: t, alt: e, className: "object-cover object-center w-full", loading: "lazy" }) });
export {
  m as C
};
